import { Button } from '@forma/forma-ui-kit';
import Logo from '@/components/Logo';
import Link from '@/components/Link';

import styles from './signature-banner.module.css';

const SignatureBanner = ({ name, title, href }) => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Logo className={styles.logo} type="block" />
        <div className={styles.name}>{name}</div>
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.buttons}>
        <Button as={Link} className={styles.button} size="small" href={href}>
          Подробнее
        </Button>
      </div>
    </div>
  );
};

export default SignatureBanner;
